import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-edit-position',
  standalone: true,
  imports: [],
  templateUrl: './confirmation-edit-position.component.html',
  styleUrl: './confirmation-edit-position.component.sass'
})
export class ConfirmationEditPositionComponent {

  @Input() projectId: string = '';
  @Input() confirmationId: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter();
}
